import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: $props.to,
    class: _normalizeClass({ 'gfu-balloon__content-link': !_ctx.onlyIcon })
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(['gfu-btn--toggler', _ctx.onlyIcon ? `gfu-btn gfu-btn--circle gfu-btn--${_ctx.type}` : 'gfu-balloon__content-icon'])
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 0,
              name: _ctx.icon
            }, null, 8 /* PROPS */, ["name"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      (!_ctx.onlyIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            "data-qa": $options.qaKey
          }, _toDisplayString(_ctx.label), 9 /* TEXT, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to", "class"]))
}